import ContenutoArchivioView from "./ContenutoArchivioView";
import {useContext, useEffect, useState} from "react";
import {getDocumentiArchivioApi} from "../services/ArchivioServices";
import {RuoliContext} from "../../../context/RuoliContext";
import {LoaderContext} from "../../../context/LoaderContext";
import {FiltersContext} from "../../../context/FiltersContext";

export default function ContenutoArchivioController({
                                                        titolo,
                                                        tema,
                                                        handlerRefreshTabs,
                                                        sottotema = null,
                                                    }) {

    const [documenti, setDocumenti] = useState([]);
    const [showModalAddDoc, setShowModalAddDoc] = useState(false);

    const {
        isRuoloSocio,
        isRuoloClub,
        isRuoloAgenzia,
    } = useContext(RuoliContext);
    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {filtroArchivio} = useContext(FiltersContext);

    async function getDocumenti() {
        const filtri = getStrFiltroDocumenti();

        startChiamata();
        const response = await getDocumentiArchivioApi(titolo.id_archivio_titolo, tema.id_archivio_tema, filtri);
        endChiamata();

        setDocumenti(response.data.data);
    }

    function getStrFiltroDocumenti() {
        let f = '';

        if (filtroArchivio['id_archivio_marca'] && filtroArchivio['id_archivio_marca'] !== '') {
            f += `${f === '' ? '?' : '&'}id_archivio_marca=${filtroArchivio['id_archivio_marca']}`;
        }
        if (filtroArchivio['marca'] && filtroArchivio['marca'] !== '') {
            f += `${f === '' ? '?' : '&'}marca=${filtroArchivio['marca']}`;
        }
        if (filtroArchivio['modello'] && filtroArchivio['modello'] !== '') {
            f += `${f === '' ? '?' : '&'}modello=${filtroArchivio['modello']}`;
        }
        if (filtroArchivio['inizioProd'] && filtroArchivio['inizioProd'] !== '') {
            f += `${f === '' ? '?' : '&'}inizioProd=${filtroArchivio['inizioProd']}`;
        }
        if (filtroArchivio['fineProd'] && filtroArchivio['fineProd'] !== '') {
            f += `${f === '' ? '?' : '&'}fineProd=${filtroArchivio['fineProd']}`;
        }
        if (filtroArchivio['annoDocDa'] && filtroArchivio['annoDocDa'] !== '') {
            f += `${f === '' ? '?' : '&'}annoDocDa=${filtroArchivio['annoDocDa']}`;
        }
        if (filtroArchivio['annoDocA'] && filtroArchivio['annoDocA'] !== '') {
            f += `${f === '' ? '?' : '&'}annoDocA=${filtroArchivio['annoDocA']}`;
        }
        if (sottotema && sottotema !== '') {
            f += `${f === '' ? '?' : '&'}tipo=${sottotema}`;
        }
        return f;
    }

    useEffect(() => {
        getDocumenti();
    }, [tema, titolo, filtroArchivio]);

    return (
        <ContenutoArchivioView
            documenti={documenti}
            tema={tema}
            sottotema={sottotema}
            titolo={titolo}
            isRuoloAd={!isRuoloSocio() && !isRuoloClub() && !isRuoloAgenzia()}
            openModalAddDocumento={() => {
                setShowModalAddDoc(true);
            }}
            closeModalAddDocumento={() => {
                setShowModalAddDoc(false);
            }}
            addDocumentoOk={() => {
                setShowModalAddDoc(false);
                getDocumenti();
                handlerRefreshTabs();
            }}
            showModalAddDoc={showModalAddDoc}
        />
    );
}